import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "./MobileMyBooks.css";
import { withRouter } from "react-router";

class MobileMyBooks extends Component {
  render() {
    const { classes, books } = this.props;
    return (
      <div>
        {books.map((book, index) => (
          <Paper
            key={index}
            className={classes.paper}
            onClick={() =>
              this.props.history.push(`/books/details/${book._id}`)
            }
          >
            <img
              src={book.bookCoverUrl}
              alt={book.title}
              style={{ width: 100, height: 100 }}
            />
            <div style={{ padding: 10 }}>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                {book.title}
              </div>
              <div style={{ fontSize: 16 }}>
                By {book.author.firstName} {book.author.middleName}
                {book.author.lastName}
              </div>
              <div style={{ fontSize: 14 }}>{book.genre}</div>
            </div>
          </Paper>
        ))}
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(MobileMyBooks));
